import Api from '../../utils/api';
import {
  API_PAYMENT_PACKS,
} from '../../configs/apis';
import {
  API_PAYMENT_PACKS_FETCH,
  API_PAYMENT_PACKS_FETCH_SUCCESS,
  API_PAYMENT_PACKS_FETCH_ERROR,
} from '../types';

export function fetchPaymentPacks(appId) {
  return async (dispatch) => {
    try {
      dispatch({type: API_PAYMENT_PACKS_FETCH, appId});
      const response = await Api.get(API_PAYMENT_PACKS, {}, {appId});
      return dispatch({type: API_PAYMENT_PACKS_FETCH_SUCCESS, response});
    } catch (error) {
      return dispatch({type: API_PAYMENT_PACKS_FETCH_ERROR, error: error.message});
    }
  };
}
